import script from "./EnquiriesView.vue?vue&type=script&setup=true&lang=js"
export * from "./EnquiriesView.vue?vue&type=script&setup=true&lang=js"

import "./EnquiriesView.vue?vue&type=style&index=0&id=d99c5448&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d99c5448"]])

export default __exports__